import { render, staticRenderFns } from "./SampleRequestsList.vue?vue&type=template&id=06fb33a2&"
import script from "./SampleRequestsList.vue?vue&type=script&lang=js&"
export * from "./SampleRequestsList.vue?vue&type=script&lang=js&"
import style0 from "./SampleRequestsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports